export default {
  // HTTP
  HTTP_URL: "http.url",
  HTTP_METHOD: "http.method",
  HTTP_USER_AGENT: "http.user_agent",
  HTTP_RESPONSE_CONTENT_LENGTH: "http.response_content_length",
  HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED: "http.response_content_length_uncompressed",
  HTTP_STATUS_CODE: "http.status_code",

  // Page
  PAGE_URL: "page.url",
  PAGE_HASH: "page.hash",
  PAGE_ROUTE: "page.route",
  PAGE_HOSTNAME: "page.hostname",
  PAGE_SEARCH: "page.search",

  // URL
  URL_PATH: "url.path",

  // Custom
  INITIATOR_TYPE: "initiator_type",
  DELIVERY_TYPE: "delivery_type",
  SIZE: "size",

  // Exception
  EXCEPTION_TYPE: "exception.type",
  EXCEPTION_MESSAGE: "exception.message",
  EXCEPTION_STACKTRACE: "exception.stacktrace",
};
